import React, {useEffect, useState} from "react";
import {Button, Col, Form, Modal, notification, Radio, Row, Spin, Upload} from "antd";
import DividerBlock from "../../divider-block";
import FieldBlock from "../../field-block";
import {formHelper} from "../../../helpers";
import "../modals.css";
import i18n from "i18next";
import {legalEntityService} from "../../../services/legal-entity.service";
import InputField from "../../input-field";

export default function ModalEditLegalEntityConsignorGosLog({isShow, setIsShow, consignorId, legalEntityId, status = '1',onSubmitSuccess}) {
  const [loading, setLoading] = useState(true);
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [docFields, setFields] = useState({});
  const [errors, setError] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [docsList, setDocsList] = useState(null);
  const [gosLogDocKind, setGosLogDocKind] = useState("extract");
  const [extractNumber, setExtractNumber] = useState("");
  const gosLogFileAlias = gosLogDocKind === 'extract' ? 'documentGosLogExtract' : 'documentGosLogStatement';

  useEffect(() => {
    if (isShow) {
      setFields({});
      setError({});
      setFieldsErrors({});
      setDocsList(null);
      setIsDisabled(true);
      setGosLogDocKind("extract");
      setExtractNumber("");
      setLoading(false);
    }
  }, [isShow]);

  useEffect(() => {
    const hasFile = !!(docFields && docFields[gosLogFileAlias] && docFields[gosLogFileAlias].length === 1);
    const needNumber = gosLogDocKind === "extract";
    const hasNumber = extractNumber && String(extractNumber).trim().length > 0;
    setIsDisabled(!(hasFile && (!needNumber || hasNumber)));
  }, [docFields, gosLogDocKind, extractNumber]);

  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => fieldErrors + "; " + error)
      : null;
  };

  const getUploaderClass = (name, maxFiles = null) => {
    if (maxFiles === 1) {
      return {
        multiple: false,
        showUploadList: true,
        onRemove: () => {
          setFields({...docFields, [name]: []});
        },
        beforeUpload: (file) => {
          if (file.type === "application/pdf") {
            file.thumbUrl = "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
          } else {
            file.url = URL.createObjectURL(
              file instanceof File ? file : formHelper.b64toBlob(file, "image/png")
            );
          }
          setError({...errors, [name]: ''});
          setFields({...docFields, [name]: [file]});
          return false;
        },
        listType: "picture",
      };
    }
    return {
      multiple: true,
      showUploadList: true,
      onRemove: (file) => {
        if (!docFields[name]) return;
        docFields[name].forEach((stepFile, index) => {
          if (stepFile.uid === file.uid) {
            docFields[name].splice(index, 1);
          }
          setFields({...docFields, [name]: docFields[name]});
        });
      },
      beforeUpload: (file, fileList) => {
        if (file.type === "application/pdf") {
          file.thumbUrl = "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
        } else {
          file.url = URL.createObjectURL(
            file instanceof File ? file : formHelper.b64toBlob(file, "image/png")
          );
        }

        const isCorrectFiles = formHelper.checkFiles(fileList, docFields[name], setError, errors, name);
        if (isCorrectFiles) {
          setError({...errors, [name]: ''});
          if (docFields[name]) {
            setFields({
              ...docFields,
              [name]: docFields[name].concat(fileList),
            });
          } else {
            setFields({...docFields, [name]: fileList});
          }
        }

        return false;
      },
      listType: "picture",
    };
  };

  const submitBtnStyle = {
    width: "190px",
    height: "40px",
    background: "#1CAA53",
    position: "static",
    borderRadius: "10px",
    borderColor: "#1CAA53",
  };

  const DownloadIcon = () => {
    return (
      <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg"
           className="download-file-svg">
        <path
          d="M11.5631 0.165835C11.4647 0.0622087 11.3298 0 11.19 0H2.81953C1.27495 0 0 1.26988 0 2.81429V18.643C0 20.1875 1.27495 21.4574 2.81953 21.4574H14.1805C15.725 21.4574 17 20.1875 17 18.643V6.07435C17 5.93962 16.9378 5.81013 16.8497 5.71158L11.5631 0.165835ZM11.7134 1.82959L15.2534 5.54574H12.9522C12.268 5.54574 11.7134 4.99634 11.7134 4.31221V1.82959ZM14.1805 20.4208H2.81953C1.85038 20.4208 1.03659 19.6175 1.03659 18.643V2.81429C1.03659 1.84514 1.84514 1.03659 2.81953 1.03659H10.6768V4.31221C10.6768 5.57161 11.6928 6.58233 12.9522 6.58233H15.9634V18.643C15.9634 19.6175 15.1549 20.4208 14.1805 20.4208Z"
          fill="#1CAA53"></path>
        <path
          d="M12.7642 16.8447H4.23314C3.94813 16.8447 3.71484 17.0778 3.71484 17.363C3.71484 17.648 3.94813 17.8813 4.23314 17.8813H12.7695C13.0545 17.8813 13.2878 17.648 13.2878 17.363C13.2878 17.0778 13.0545 16.8447 12.7642 16.8447Z"
          fill="#1CAA53"></path>
        <path
          d="M5.84741 11.268L7.9828 8.97187V14.6317C7.9828 14.9167 8.21608 15.15 8.5011 15.15C8.78627 15.15 9.01939 14.9167 9.01939 14.6317V8.97187L11.1548 11.268C11.2584 11.3767 11.3933 11.4339 11.5331 11.4339C11.6575 11.4339 11.7872 11.3872 11.8856 11.2939C12.093 11.097 12.1085 10.7704 11.9116 10.5631L8.87435 7.30304C8.7758 7.19942 8.64107 7.13721 8.49602 7.13721C8.35081 7.13721 8.21608 7.19942 8.11769 7.30304L5.08044 10.5631C4.8835 10.7704 4.89906 11.102 5.10631 11.2939C5.32404 11.4908 5.65047 11.4753 5.84741 11.268Z"
          fill="#1CAA53"></path>
      </svg>
    );
  };

  const onSubmitForm = () => {
    if (!consignorId) {
      notification.error({
        message: i18n.t('Обновление статуса регистрации в ГосЛог'),
        description: 'Не определён consignorId',
      });
      return;
    }
    if (!legalEntityId) {
      notification.error({
        message: i18n.t('Обновление статуса регистрации в ГосЛог'),
        description: 'Не определён legalEntityId',
      });
      return;
    }
    setLoading(true);
    const numberExtract = gosLogDocKind === "extract" ? String(extractNumber).trim() : null;
    legalEntityService.changeConsignorGosLog(consignorId, legalEntityId, docFields, '', numberExtract, status)
      .then((response) => {
        if (response && response.code === 400) {
          notification.error({
            message: i18n.t('Обновление статуса регистрации в ГосЛог'),
            description: response.message,
          });
          setFieldsErrors(response.errors);
          return;
        }

        if (response && response.status === 'success') {
          if (typeof onSubmitSuccess === 'function') {
            onSubmitSuccess(response.message);
          } else {
            notification.success({
              message: i18n.t('Обновление статуса регистрации в ГосЛог'),
              description: response.message,
            });
          }
          setIsShow(false);
          return;
        }

        if (response instanceof Object) {
          setDocsList(Object.values(response));
        } else {
          setDocsList(response);
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('Обновление статуса регистрации в ГосЛог'),
          description: err,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('Статус регистрации в ГосЛог')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => setIsShow(false)}
      footer={[
        <Button
          htmlType="submit"
          style={submitBtnStyle}
          key="submit"
          type="primary"
          onClick={() => onSubmitForm()}
          disabled={isDisabled || loading}
        >
          {i18n.t('main.buttons.save')}
        </Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Form>
          <Row>
            <p>{i18n.t('Вступаете ли Вы в реестр уведомлений о транспортно экспедиционной деятельности в соответствии с Федеральным законом от 07.06.2025 № 140 ФЗ «О внесении изменений в Федеральный закон «О транспортно экспедиционной деятельности» и отдельные законодательные акты Российской Федерации» с 01.03.2026?')}</p>
          </Row>
          <DividerBlock/>
          <Row>
            <p>{i18n.t('Данный грузоотправитель требует документы о регистрации в ГосЛог. Вы можете загрузить "ВЫПИСКУ ИЗ РЕЕСТРА УВЕДОМЛЕНИЙ О ТРАНСПОРТНО-ЭКСПЕДИЦИОННОЙ ДЕЯТЕЛЬНОСТИ" и указать рег. номер или "Заявление о регистрации в реестре", но в дальнейшем Вам все равно придется дозагрузить Выписку. После согласования, вам в кабинет придет уведомление.')}</p>
          </Row>
          <Row style={{marginTop: '10px'}}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Radio.Group
                value={gosLogDocKind}
                onChange={(e) => {
                  const nextValue = e.target.value;
                  setGosLogDocKind(nextValue);
                  setFields({});
                  setError({});
                  if (nextValue !== "extract") {
                    setExtractNumber("");
                  }
                }}
              >
                <Radio value="extract">Выписка из реестра</Radio>
                <Radio value="application">Заявление о регистрации в реестре</Radio>
              </Radio.Group>
            </Col>
          </Row>
          {gosLogDocKind === "extract" && (
            <Row gutter={[12, 24]} style={{marginTop: '10px'}}>
              <Col lg={12} md={24} sm={24} xs={24}>
                <InputField
                  name="number_extract"
                  label="Номер выписки"
                  required={true}
                  value={extractNumber}
                  setValue={(value) => setExtractNumber(value)}
                  getFieldErrors={() => null}
                />
              </Col>
            </Row>
          )}
          <Row gutter={[12, 24]} style={{marginTop: '20px'}}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <FieldBlock
                name={gosLogFileAlias}
                getErrors={() => errors[gosLogFileAlias] ? errors[gosLogFileAlias] : getFieldErrors(gosLogFileAlias)}
              >
                <Upload
                  defaultFileList={docFields[gosLogFileAlias]}
                  fileList={docFields[gosLogFileAlias]}
                  className="single-btn-upload"
                  {...getUploaderClass(gosLogFileAlias, 1)}
                >
                  <Button style={{textAlign: "left"}} htmlType="button">
                    <DownloadIcon/>
                    {gosLogDocKind === 'extract' ? 'Выписка из реестра' : 'Заявление о регистрации в реестре'}
                  </Button>
                </Upload>
              </FieldBlock>
            </Col>
          </Row>
          {docsList && <Row gutter={[12, 24]} style={{marginTop: '20px'}}>
            {docsList.map((doc, index) => (
              <Col lg={12} md={24} sm={24} xs={24} key={index + 1}>
                <FieldBlock name={doc.requestName} getErrors={getFieldErrors}>
                  <Upload defaultFileList={docFields[doc.requestName]}
                          fileList={docFields[doc.requestName]}
                          className="single-btn-upload" {...getUploaderClass(doc.requestName)}>
                    <Button style={{textAlign: "left"}} htmlType="button">
                      <DownloadIcon/>
                      {doc.description}
                    </Button>
                  </Upload>
                </FieldBlock>
              </Col>
            ))}
          </Row>}
        </Form>
      </Spin>
    </Modal>
  );
}
